/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { useApplicationsPaginatedQuery } from "~/generated/graphql";
import { useCurrency } from "~/hooks";
import { mapApplicationWithEnvironment } from "~/tools/applicationMapper";

export function useMappedApplications(
  variables: Parameters<typeof useApplicationsPaginatedQuery>[0]["variables"]
) {
  const { data, ...result } = useApplicationsPaginatedQuery({
    variables,
    errorPolicy: "all",
  });

  const { currency } = useCurrency();

  const count = data?.applicationsPaginated?.count ?? 0;
  const applications = useMemo(
    () =>
      data?.applicationsPaginated?.results?.map((application) =>
        mapApplicationWithEnvironment(application, currency)
      ) ?? [],
    [currency, data?.applicationsPaginated?.results]
  );

  return {
    applications,
    count,
    ...result,
  };
}
